module.exports = __webpack_public_path__ + "sgby/img/feature-next.9020670.png";